/* Spanish catalog mirroring locale-payroll-employees-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'pay.personalia': 'Datos personales',
  'pay.personalInfo': 'Información personal',
  'pay.edit': 'Editar',
  'pay.documents': 'Documentos',
  'pay.description': 'Descripción',
  'pay.contract': 'Contrato de trabajo',
  'pay.open': 'Abrir',
  'pay.download': 'Descargar',
  'pay.delete': 'Eliminar',
  'pay.employment': 'Relación laboral',
  'pay.positionAndAgreement': 'Puesto y acuerdo',
  'pay.searchOccupationCodes': 'Buscar códigos de ocupación ...',
  'pay.cancel': 'Cancelar',
  'pay.saveEmployment': 'Guardar relación laboral',
  'pay.employmentFrom': 'Relación laboral válida desde',
  'pay.employmentFromHint': 'La fecha en que el empleado tuvo, o tendrá, su primer día de trabajo en tu empresa. Esta fecha es independiente de cuándo empezaste a llevar la contabilidad en Plumme.',
  'pay.endDate': 'Fecha de fin',
  'pay.endDateHint': 'Deja el campo vacío mientras la relación laboral siga abierta.',
  'pay.occupationCode': 'Código de ocupación',
  'pay.occupationCodeHint': 'Busca en el registro público de códigos de ocupación y elige la mejor coincidencia. El campo se usa para estadísticas de ocupaciones en Noruega.',
  'pay.employmentType': 'Tipo de relación laboral',
  'pay.employmentForm': 'Forma de empleo',
  'pay.workingHoursScheme': 'Régimen de jornada',
  'pay.workingHoursSchemeHint': 'La mayoría de los empleados no trabajan por turnos, pero algunos entrarán en las otras categorías.',
  'pay.hoursFullWeek': 'Horas de una semana completa',
  'pay.hoursFullWeekHint': 'Número de horas de trabajo en una semana completa si el empleado trabaja al 100 %. Normalmente 37,5 horas.',
  'pay.salaryType': 'Tipo de salario',
  'pay.hourlyPay': 'Salario por hora',
  'pay.fixedPay': 'Salario fijo',
  'pay.ftePercent': 'Porcentaje de jornada completa',
  'pay.ftePercentHint': 'Elige un porcentaje estimado de jornada completa. Si no estás seguro, usa el porcentaje más cercano.',
  'pay.fullTime': 'Jornada completa',
  'pay.partTime': 'Jornada parcial',
  'pay.employmentScope': 'Dedicación',
  'pay.adjustHoursBy': 'Ajustar horas por',
  'pay.perWeek': 'Por semana',
  'pay.perMonth': 'Por mes',
  'pay.hoursPerWeek': 'Horas por semana',
  'pay.hoursPerMonth': 'Horas por mes',
  'pay.otherEntityNumber': 'Otro número de entidad',
  'pay.optionalEntityNumber': 'Número de entidad (opcional)',
  'pay.priorPayOutsidePlumme': 'Salario anterior fuera de Plumme pagado por tu empresa',
  'pay.priorPayHelp': 'Introduce solo el salario que no está registrado en Plumme pero que la empresa ha pagado.',
  'pay.warning': 'Advertencia:',
  'pay.forPublicStatistics': 'Para estadísticas públicas: rellénalo solo si procede',
  'pay.lastAdjustmentDate': 'Fecha del último ajuste salarial',
  'pay.salaryGrade': 'Nivel salarial',
  'pay.salaryGradePh': 'P. ej. 45',
  'pay.agreedSalary': 'Salario acordado',
  'pay.save': 'Guardar',
  'pay.annualSalary': 'Salario anual',
  'pay.agreementTaxHeading': 'Acuerdo, vacaciones pagadas, impuestos y cotización del empleador',
  'pay.tax': 'Impuestos',
  'pay.notFetchedFromAltinn': 'No obtenido de Altinn',
  'pay.salaryPerYear': 'Salario por año',
  'pay.holidayPay': 'Vacaciones pagadas',
  'pay.employerContribution': 'Cotización del empleador a la seguridad social',
  'pay.estimatedTax': 'Impuestos estimados',
  'pay.estimatedAnnualCost': 'Coste anual estimado',
  'pay.noAgreedSalary': 'No se ha introducido ningún salario acordado',
  'pay.taxCard': 'Tarjeta fiscal',
  'pay.taxCardHelp': 'Las tarjetas fiscales aún no se obtienen. Se conectarán cuando la integración con Skatteetaten esté lista.',
  'pay.fixedLines': 'Líneas recurrentes',
  'pay.fixedLinesHelp': 'Líneas salariales que normalmente se incluyen en cada pago.',
  'pay.newFixedLine': 'Crear una nueva línea recurrente',
  'pay.seeFixedLines': 'Ver líneas salariales recurrentes',
  'pay.payslips': 'Recibos de nómina',
  'pay.noPayslips': 'Todavía no se ha creado ningún recibo de nómina.',
  'pay.gross': 'Bruto',
  'pay.paidOut': 'Pagado',
  'pay.employeePortal': 'Portal del empleado',
  'pay.employeePortalSub': 'Recibos de nómina, viajes y gastos del empleado.',
  'pay.needEmailFirst': 'Introduce un correo electrónico válido en el perfil del empleado antes de conceder el acceso.',
  'pay.goToTravelExpenses': 'Ir a viajes y gastos',
  'pay.saveEmployee': 'Guardar empleado',
  'pay.nationalId': 'Número de identidad nacional',
  'pay.hasInternationalId': 'Tiene un ID internacional',
  'pay.name': 'Nombre',
  'pay.phone': 'Número de teléfono',
  'pay.email': 'Correo electrónico',
  'pay.address': 'Dirección',
  'pay.country': 'País',
  'pay.address1': 'Dirección 1',
  'pay.streetAddress': 'Calle y número',
  'pay.address2': 'Dirección 2',
  'pay.optional': 'Opcional',
  'pay.postalCode': 'Código postal',
  'pay.postalPlace': 'Localidad',
  'pay.postalPlacePh': 'Localidad ...',
  'pay.accountNumber': 'Número de cuenta',
  'pay.hasForeignAccount': 'Tiene un número de cuenta extranjero',
  'pay.mainOrSecondaryEmployer': 'Empleador principal/secundario',
  'pay.taxAndDutyRules': 'Normas de impuestos y cotizaciones',
  'pay.noteOptional': 'Nota (opcional)',
  'pay.notePh': 'Escribe una nota ...',
  'pay.employees': 'Empleados',
  'pay.employeesHelp': 'El registro de todas las personas empleadas por la empresa. Toca un empleado para ver sus datos personales, relación laboral, salario y recibos de nómina.',
  'pay.allEmployees': 'Todos los empleados de tu empresa',
  'pay.newEmployee': 'Nuevo empleado',
  'pay.newEmployeeHelp': 'Registra un nuevo empleado con sus datos personales, relación laboral y condiciones salariales. Después se incluirá en los procesos de nómina y en la a-melding.',
  'pay.noEmployees': 'Todavía no hay empleados',
  'pay.salaryTypeLabel': 'Tipo de salario:',
  'pay.status': 'Estado',
  'pay.statusHelp': 'Una relación laboral activa significa que el empleado se incluye en los procesos de nómina. Finalizada significa que la relación laboral ha terminado.',
  'pay.payroll': 'Nómina',
  'pay.payrollSub': 'Ejecuta la nómina y haz seguimiento de empleados, periodos y vacaciones pagadas.',
  'pay.payrollModuleHelp': 'El módulo de nómina reúne todo lo relativo a empleados y salarios: ejecución de la nómina, cotización del empleador y retención en origen, pensión (OTP), vacaciones pagadas, viajes y gastos, y ajustes. Cambia entre las subpáginas en el menú desplegable.',
  'pay.payrollPages': 'Páginas de nómina',
  'pay.payrollPagesHelp': 'Cambia entre las subpáginas de nómina: Empleados, Proceso de nómina, Cotización del empleador e impuestos, Pensión/OTP, Líneas salariales recurrentes, Viajes y gastos, Resumen de nómina, Lista de vacaciones pagadas, Ajustes de nómina y Tipos de salario.',
  'pay.employmentStatus': 'Estado de la relación laboral',
  'pay.employmentStatusHelp': 'Muestra si la relación laboral está activa o finalizada. Los empleados activos se incluyen en los procesos de nómina y se declaran en la a-melding.',
  'pay.backToPayrollRun': 'Volver al proceso de nómina',
  'pay.showAllEmployees': 'Mostrar todos los empleados',
  'pay.yourEmployers': 'Tus empleadores',
  'pay.yourClients': 'Tus clientes',
  'pay.bgForEmployer': 'Color de fondo de este empleador',
  'pay.bgColour': 'Color de fondo',
  'pay.receiptHelp': 'Haz una foto, sube, arrastra o pega. Los gastos sin recibo no se pueden enviar.',
  'pay.takePhoto': 'Hacer una foto',
  'pay.uploadFile': 'Subir imagen/archivo',
  'pay.remove': 'Quitar',
  'pay.registerExpense': 'Registrar gasto',
  'pay.receiptRequired': 'Se requiere un recibo',
  'pay.category': 'Categoría',
  'pay.pickCategory': 'Elige una categoría',
  'pay.date': 'Fecha',
  'pay.paidWith': 'Pagado con',
  'pay.privateExpense': 'Gasto privado',
  'pay.companyCard': 'Tarjeta de empresa/cuenta operativa',
  'pay.amount': 'Importe',
  'pay.currency': 'Moneda',
  'pay.whatIsExpenseFor': '¿Para qué es el gasto?',
  'pay.registerTravel': 'Registrar viaje',
  'pay.sentForApproval': 'Enviado para aprobación',
  'pay.dateFrom': 'Fecha desde',
  'pay.dateTo': 'Fecha hasta',
  'pay.travelType': 'Tipo de viaje',
  'pay.travelWithExpenses': 'Viaje con gastos/desplazamiento',
  'pay.drivingOnly': 'Solo desplazamiento',
  'pay.travelWithSubsistence': 'Viaje con dietas',
  'pay.destination': 'Destino',
  'pay.destinationPh': 'Ciudad, cliente o lugar',
  'pay.from': 'Desde',
  'pay.startPlace': 'Punto de partida',
  'pay.to': 'Hasta',
  'pay.endPlace': 'Destino',
  'pay.kilometres': 'Kilómetros',
  'pay.purpose': 'Motivo',
  'pay.purposeHelp': '¿Cuál fue el motivo del viaje?',
  'pay.note': 'Nota',
  'pay.createTravelClaim': 'Crear solicitud de gastos de viaje',
  'pay.purposePh': 'P. ej. reunión con un cliente en Drammen',
  'pay.whereDidYouGo': '¿Adónde fue el viaje?',
  'pay.norway': 'Noruega',
  'pay.tolls': 'Peajes',
  'pay.tollsPaidWith': 'Peajes pagados con',
  'pay.fromDate': 'Desde la fecha',
  'pay.toDate': 'Hasta la fecha',
  'pay.type': 'Tipo',
  'pay.hotel': 'Hotel',
  'pay.otherAccommodation': 'Otro alojamiento',
  'pay.guesthouse': 'Pensión o barracón',
  'pay.place': 'Lugar',
  'pay.hotelOrPlace': 'Hotel o lugar',
  'pay.travelClaim': 'Solicitud de gastos de viaje',
  'pay.rejectedByEmployer': 'Rechazado por el empleador',
  'pay.newAccommodation': 'Nuevo alojamiento',
  'pay.newTrip': 'Nuevo viaje',
  'pay.newExpense': 'Nuevo gasto',
  'pay.noLinesYet': 'Todavía no hay líneas',
  'pay.employee': 'Empleado',
  'pay.subsistence': 'Dietas',
  'pay.payslip': 'Recibo de nómina',
  'pay.close': 'Cerrar',
  'pay.netPaid': 'Neto pagado',
  'pay.period': 'Periodo',
  'pay.payAndDeductions': 'Salario y deducciones',
  'pay.grossPay': 'Salario bruto',
  'pay.withholdingTax': 'Retención en origen',
  'pay.expenseRefund': 'Reembolso de gastos/viajes',
  'pay.payslipPdfNote': 'La vista en PDF y el envío se conectarán cuando el generador de recibos de nómina esté disponible en Plumme.',
  'pay.noPayslipsYet': 'Todavía no hay recibos de nómina.',
  'pay.myExpenses': 'Mis gastos',
  'pay.noExpensesInView': 'No hay gastos en esta vista.',
  'pay.expenses': 'Gastos',
  'pay.preview': 'Vista previa',
  'pay.loadingReceipt': 'Cargando recibo...',
  'pay.canStillDownload': 'El recibo todavía se puede descargar manualmente.',
  'pay.cannotPreview': 'Este tipo de archivo no se puede previsualizar aquí.',
  'pay.openNewTab': 'Abrir en una pestaña nueva',
  'pay.myTravel': 'Mis viajes',
  'pay.noTravelInView': 'No hay viajes en esta vista.',
  'pay.fetchingPortal': 'Obteniendo el portal del empleado',
  'pay.portalFailed': 'No se pudo obtener el portal del empleado',
  'pay.back': 'Atrás',
  'pay.noEmployers': 'No hay empleadores',
  'pay.home': 'Inicio',
  'pay.homeHelp': 'Tu página de empleado con el empleador seleccionado: recibos de nómina, gastos y viajes.',
  'pay.myPage': 'Mi página',
  'pay.myPageHelp': 'Tu cuenta personal en Plumme: perfil, empresas y finanzas personales.',
  'pay.signOut': 'Cerrar sesión',
  'pay.paidByCompanyHint': 'El recibo va a contabilidad, no a reembolso.',
  'pay.paidPrivateHint': 'Te reembolsan el importe con tu nómina.',
  'pay.expenseProject': 'Proyecto',
  'pay.expenseProjectHint': 'Un gasto de un proyecto se puede refacturar al cliente.',
  'pay.expenseNoProject': 'Sin proyecto',
  'pay.myHours': 'Mis horas',
  'pay.hoursThisMonth': '{time} este mes',
  'pay.hoursHelp': 'Las horas que has registrado en proyectos para este empleador.',
  'pay.registerHours': 'Registrar horas',
  'pay.timeNew': 'Registrar horas',
  'pay.timeEdit': 'Editar registro',
  'pay.timeDate': 'Fecha',
  'pay.timeProject': 'Proyecto',
  'pay.timeActivity': 'Actividad',
  'pay.timeHours': 'Horas',
  'pay.timeNote': 'Nota',
  'pay.timeNotePh': '¿En qué has trabajado?',
  'pay.timePickProject': 'Elige un proyecto …',
  'pay.timePickActivity': 'Elige una actividad …',
  'pay.timeSum': 'Total',
  'pay.timeSaved': 'El registro se ha guardado',
  'pay.timeDeleted': 'El registro se ha eliminado',
  'pay.timeFailed': 'No se pudo guardar el registro.',
  'pay.timeLocked': 'El control de horas de este periodo está marcado como finalizado.',
  'pay.timeLockedThrough': 'El control de horas está marcado como finalizado hasta el {date}.',
  'pay.timeEmptyTitle': 'No hay horas esta semana',
  'pay.timeEmpty': 'Pulsa «Registrar horas» para añadir la primera.',
  'pay.timeNoProjectsTitle': 'No hay proyectos',
  'pay.timeNoProjects': 'Tu empleador aún no ha creado ningún proyecto en el que puedas registrar horas.',
  'pay.timePrevWeek': 'Semana anterior',
  'pay.timeNextWeek': 'Semana siguiente',
  'pay.myEmployeePage': 'Mi página de empleado',
  'pay.myEmployeePageHelp': 'Tu página como empleado con un empleador, separada de las cuentas que lleves. Aquí ves tus recibos de nómina y registras los gastos y viajes que se te deben. Arriba cambias entre los empleadores para los que trabajas.',
  'pay.employer': 'Empleador',
  'pay.employerHelp': 'El empleador al que se aplica esta página. Si trabajas en varios sitios, cambias aquí; entonces los recibos de nómina, gastos y viajes muestran las cifras del empleador seleccionado.',
  'pay.payslipsHelp': 'Los recibos de nómina del empleador: un resumen del salario, la retención de impuestos y el neto de cada nómina. Toca para abrir.',
  'pay.expensesHelp': 'Gastos que has pagado de tu bolsillo y que te deben reembolsar, por ejemplo un recibo de una compra privada. Envíalos para aprobación y se reembolsan a través de la nómina.',
  'pay.travelHelp': 'Solicitudes de viaje con kilometraje, dietas y gastos vinculados a un viaje. Envíalas para aprobación y reembolso a través de la nómina.',
  'pay.registerExpenseHelp': 'Registra un nuevo gasto que hayas pagado: sube el recibo, introduce el importe y para qué es. Se envía al empleador para su aprobación y reembolso.',
  'pay.registerTravelHelp': 'Registra una solicitud de viaje: trayectos (kilometraje), dietas y gastos vinculados al viaje. Se envía al empleador para su aprobación.',
  'pay.employmentStatusLabel.active': 'Relación laboral activa',
  'pay.employmentStatusLabel.ended': 'Baja',
  'pay.employmentStatusLabel.future': 'Empieza más adelante',
  'pay.taxRuleNotSupported': 'aún no compatible',
  'pay.taxRuleNotSupportedHint': 'Plumme solo calcula el impuesto ordinario y la cotización del empleador. Un proceso de nómina con este empleado no se puede aprobar: ejecuta la nómina de este empleado fuera de Plumme.',
  'pay.portalEmploymentEnded': 'Tu relación laboral ha terminado. Todavía puedes ver tus recibos de nómina, pero no puedes enviar nuevos gastos, solicitudes de viaje ni horas. Contacta con tu empleador si tienes un gasto pendiente de reembolso.',
  'err.employeePortal.employmentEnded': 'La relación laboral ha terminado y el portal del empleado es ahora de solo lectura. Pide al empleador que registre el gasto.',
  'pay.foreignAmount.label': 'Importe pagado en NOK',
  'pay.foreignAmount.hint': 'El recibo está en {currency}. Introduce lo que realmente pagaste en coronas noruegas, por ejemplo según tu extracto bancario. El gasto no se puede aprobar sin un importe en NOK.',
  'pay.foreignAmount.rateHint': 'Equivale a un tipo de {rate} NOK por {currency}.',
  'pay.foreignAmount.missing': 'Falta el importe en NOK',
  'pay.foreignAmount.missingOnApproval': 'El gasto «{description}» está en {currency} y no tiene importe en NOK. Edita la línea e introduce el importe realmente pagado en NOK antes de aprobar.',
  'err.payroll.foreignAmountMissingNok': 'Un gasto en moneda extranjera no tiene importe en NOK. Introduce el importe realmente pagado en NOK antes de aprobar.',
  'pay.tabSalaryTax': 'Salario e impuestos',
  'pay.tabPayslipsExpenses': 'Recibos de nómina y gastos',
  'pay.taxRuleOption.ordinary': 'Ordinario',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen y las dependencias',
  'pay.taxRuleOption.seafarerDeduction': 'Deducción especial para marinos',
  'pay.taxRuleOption.charity': 'Organización benéfica o sin ánimo de lucro',
  'pay.taxRuleOption.netPay': 'Salario neto',
  'pay.taxRuleOption.netPaySeafarer': 'Salario neto para marinos',
  'pay.taxRuleOption.pensionSourceTax': 'Retención en origen sobre pensiones',
  'pay.taxRuleOption.nanny': 'Niñera en el hogar del niño',
  'pay.taxRuleOption.homeWork': 'Trabajo remunerado en el hogar',
  'pay.taxRuleOption.taxFreeOrg': 'Organización exenta de impuestos',
  'pay.employmentTypeOption.ordinary': 'Empleo ordinario',
  'pay.employmentTypeOption.maritime': 'Empleo marítimo',
  'pay.employmentTypeOption.freelance': 'Autónomo, contratista o perceptor de honorarios',
  'pay.employmentTypeOption.pension': 'Pensión u otra relación sujeta a impuestos',
  'pay.employmentTypeOption.notEmployed': 'Sin empleo',
  'pay.employmentTypeOption.simplifiedPrivate': 'Régimen de liquidación simplificado, empleador privado',
  'pay.employmentTypeOption.simplifiedCharity': 'Régimen de liquidación simplificado, organización benéfica',
  'pay.employmentTypeOption.foreignService': 'Relación de servicio en el extranjero',
  'pay.employmentTypeOption.boardFee': 'Honorarios de consejo',
  'pay.employmentFormOption.permanent': 'Indefinido',
  'pay.employmentFormOption.temporary': 'Temporal',
  'pay.employmentFormOption.temporarySubstitute': 'Sustituto temporal a demanda',
  'pay.employmentFormOption.permanentHiredOut': 'Empleo indefinido, cedido',
  'pay.employmentFormOption.temporaryHiredOut': 'Empleo temporal, cedido',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Salario por hora: horas extra',
  'pay.fixedLine': 'Línea fija',
  'pay.portalAccess.notInvited': 'Sin acceso concedido',
  'pay.portalAccess.active': 'Acceso activo',
  'pay.portalAccess.revoked': 'Acceso revocado',
  'pay.documentUploaded': 'Documento subido.',
  'pay.documentsUploaded': 'Documentos subidos.',
  'pay.documentDeleted': 'Documento eliminado.',
  'pay.amountRequired': 'Introduce un importe.',
  'pay.fixedLineDeleted': 'Línea salarial fija eliminada.',
  'pay.fixedLineDeleteFailed': 'No se pudo eliminar la línea salarial fija.',
  'pay.emailRequiredFirst': 'Primero introduce un correo electrónico válido en el perfil del empleado.',
  'pay.portalAccessSent': 'Acceso enviado a {email}.',
  'pay.portalAccessRevokedToast': 'Acceso revocado.',
  'pay.portalAccessSendFailed': 'No se pudo enviar el acceso.',
  'pay.portalAccessRevokeFailed': 'No se pudo revocar el acceso.',
  'pay.saveEmployeeFailed': 'No se pudo guardar el empleado.',
  'pay.confirmDeleteDocument': '¿Eliminar el documento «{name}»?',
  'pay.confirmDeleteFixedLine': '¿Eliminar la línea salarial fija «{line}» de {name}?',
  'pay.confirmRevokePortalAccess': '¿Revocar el acceso al portal del empleado de {name}?',
  'pay.taxCardValidUntil': 'Tarjeta fiscal válida hasta',
  'pay.leaveOfAbsence': 'Ausencias',
  'pay.noLeaveRegistered': 'Ninguna registrada',
  'pay.loginEmail': 'Correo de inicio de sesión',
  'pay.lastSent': 'Último envío',
  'pay.revoked': 'Revocado',
  'pay.bankAccount': 'Cuenta bancaria',
  'pay.hoursInFullWeek': 'Horas de una semana completa',
  'pay.uploading': 'Subiendo ...',
  'pay.newDocument': 'Nuevo documento',
  'pay.resendAccess': 'Reenviar acceso',
  'pay.grantEmployeeAccess': 'Conceder acceso al empleado',
  'pay.revoking': 'Revocando ...',
  'pay.revokeAccess': 'Revocar acceso',
  'pay.portalAccessExplain': 'El acceso está vinculado al correo electrónico y al ID del empleado. La propia interfaz del empleado usa este enlace cuando el inicio de sesión del portal esté conectado.',
  'pay.useStandardHolidayRate': 'Usar la tasa estándar de los ajustes de nómina ({rate} %)',
  'pay.priorYearSalaryHeading': 'Salario en {year}',
  'pay.payrollDataHidden': 'Los datos de nómina están ocultos para este acceso',
  'pay.payrollDataHiddenBody': 'Los empleados, las líneas salariales fijas y los procesos de nómina se guardan en un documento de personal aparte. Tu rol en este cliente es {role} y la aplicación no pudo leer el documento de personal. Por eso aún se pueden mostrar los viajes y gastos contabilizados.',
  'pay.unknownAccess': 'acceso desconocido',
  'pay.readAccess': 'Acceso de lectura',
  'pay.registerFirstEmployee': 'Registra a tu primer empleado para usar los procesos de nómina, las tarjetas fiscales y la a-melding.',
  'pay.mainEmployerOption': 'Empleador principal',
  'pay.secondaryEmployerOption': 'Empleador secundario',
  'pay.documentsCount': '{count} documentos',
  'pay.noDocumentsUploaded': 'No hay documentos subidos',
  'pay.cannotOpenDocument': 'No se pudo abrir el documento.',
  'pay.cannotDownloadDocument': 'No se pudo descargar el documento.',
  'pay.endEmployment': 'Finalizar relación laboral',
  'pay.reopenEmployment': 'Reabrir relación laboral',
  'pay.earnedHolidayPayInYear': 'Vacaciones pagadas devengadas en {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Vacaciones pagadas que no se habían abonado antes de la fecha de inicio en Plumme.',
  'pay.earnedTaxablePayInYear': 'Salario imponible devengado en {year}',
  'pay.grossPayNotInPlummeHint': 'Salario bruto pagado por la empresa en {year} que no está registrado en Plumme.',
  'pay.withheldTaxInYear': 'Impuestos retenidos en {year}',
  'pay.priorYearAmountWarning': 'Los importes de {year} solo deben rellenarse si no están incluidos en otros procesos de nómina registrados en Plumme.',
  'pay.agreedSalaryInternalNote': 'El salario acordado solo se usa como documentación interna. Los procesos de nómina se basan en líneas salariales fijas o manuales.',
  'pay.estimatedAnnualSalaryFrom': 'El salario anual estimado se calcula a partir de {summary}',
  'pay.fixedLinesRegisteredCount': '{count} registradas',
  'pay.fixedLinesOnEmployee': 'Líneas salariales fijas de este empleado.',
  'pay.noFixedLinesRegistered': 'Todavía no hay líneas fijas registradas.',
  'pay.internalDocumentationNote': 'Esto es documentación interna. Los procesos de nómina usan líneas salariales fijas o líneas manuales en el proceso de nómina.',
  'pay.noAgreedSalaryBody': 'Introduce un salario anual o por hora para ver el coste anual estimado, las vacaciones pagadas, la cotización del empleador y los impuestos.',
  'pay.selectOccupationCode': 'Selecciona un código de ocupación ...',
  'pay.noOccupationCodeMatch': 'No hay coincidencias para «{query}».',
  'pay.editEmployeeTitle': 'Editar empleado',
  'pay.newEmployeeTitle': 'Nuevo empleado',
  'err.nativeValidation.payrollManualAMelding.1': 'El registro manual de la a-melding requiere nómina noruega.',
  'err.nativeValidation.payrollManualAMelding.2': 'El envío manual debe confirmarse de forma explícita.',
  'err.nativeValidation.payrollManualAMelding.3': 'Se requieren un periodo de declaración válido, la fecha de envío y una referencia manual.',
  'err.nativeValidation.payrollManualAMelding.4': 'La fecha de envío manual debe ser posterior al mes de la declaración y no puede estar en el futuro.',
  'err.nativeValidation.payrollManualAMelding.5': 'Confirma exactamente los procesos de nómina contabilizados en el mes de la declaración.',
  'err.nativeValidation.payrollManualAMelding.6': 'La referencia manual de la declaración ya está registrada para este mes.',
  'err.nativeValidation.pensionPremiumMutation.1': 'El pago de pensión requiere contabilidad noruega en NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Se requieren un documento de pensión y una fecha válidos.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Este flujo de pago de pensión solo admite tarifas verificadas de 2026 de la zona I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'El pago de pensión usa la cuenta bancaria en NOK 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Los importes de pensión deben ser importes finitos y no negativos en céntimos.',
  'err.nativeValidation.pensionPremiumMutation.6': 'El pago de pensión no se puede registrar antes de su fecha contable.',
  'err.nativeValidation.pensionPremiumMutation.7': 'La identidad del asiento de pensión ya está reservada.',
  'err.nativeValidation.pensionPremiumMutation.8': 'El historial de numeración de pensiones no es válido.',
});
